import request from '@/utils/httpRequest'

// 青藤会员获取申请分页列表
export function getMemberApplyList (params) {
  return request({
    url: `/memberApply/listPage`,
    method: 'get',
    params
  })
}

// 审批
export function approval (data) {
  return request({
    url: `/memberApply/approval`,
    method: 'post',
    data
  })
}
